import { Box, Button, Typography } from '@mui/material';

import { MobileSectionLabelStyles, MobileSectionValueStyles } from '../styles';

import { MobileCardContainer } from './mobile-card-container';

interface MobileSectionHeaderProps {
  title: string;
  detailItems: { label: string; value: string }[];
  planId?: string;
  handleNavigateToPlan?: () => void;
}

export const MobileSectionHeader = ({
  title,
  detailItems,
  planId,
  handleNavigateToPlan,
}: MobileSectionHeaderProps) => {
  return (
    <MobileCardContainer headerTitle={title}>
      {/* Content */}
      <Box
        sx={{
          padding: '12px 16px',
          backgroundColor: '#FFFFFF',
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
        }}
      >
        {detailItems.map((item, index) => (
          <Box
            key={`${item.label}-${index}`}
            sx={{
              display: 'flex',
              minHeight: '20px',
              gap: '16px',
            }}
          >
            {/* Label Column */}
            <Box
              sx={{
                width: '104px',
                flexShrink: 0,
                minHeight: '20px',
              }}
            >
              <MobileSectionLabelStyles>{item.label}</MobileSectionLabelStyles>
            </Box>

            {/* Value Column */}
            <Box
              sx={{
                flex: 1,
                minHeight: '20px',
              }}
            >
              <MobileSectionValueStyles>{item.value || ''}</MobileSectionValueStyles>
            </Box>
          </Box>
        ))}

        {handleNavigateToPlan && (
          <>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                variant='outlined'
                color='primary'
                disabled={!planId}
                sx={{ width: '100%', borderRadius: '100px', height: '56px', fontWeight: 700 }}
                onClick={handleNavigateToPlan}
              >
                この現場の予定一覧
              </Button>
            </Box>
            {!planId && (
              <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                <Typography
                  component='span'
                  sx={{
                    color: '#74777F',
                    fontSize: '14px',
                  }}
                >
                  予定がまだ登録されていません。
                </Typography>
              </Box>
            )}
          </>
        )}
      </Box>
    </MobileCardContainer>
  );
};
